import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sainik-reports',
  templateUrl: './sainik-reports.component.html',
  styleUrls: ['./sainik-reports.component.css']
})
export class SainikReportsComponent implements OnInit {
  menuList:any;
  pageList:any;
  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Reports')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sainik-reports/sainik-reports.component.ts